module.exports = __webpack_public_path__ + "img/measurement_info_left_upper_thigh_back.30b39efc.jpg";